export const navLinks = [ 
  { path: "/", name: "Home" },
  { path: "/about", name: "About" },
  { path: "/resources-events", name: "Resources/Events" },
  { path: "/contact", name: "Contact" },
];